import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {DATABASE_NAME} from 'src/app/config/app.config';
import {STORE_DATABASE} from 'src/app/core/enums/storage/store-database.enum';
import {IndexedDBRepository} from 'src/app/shared/interface/indexed-db-storage.model';
import {BookingScrollPositionRepository} from '../../domain/repositories/booking-scroll-position.repository';
import {BookingScrollPosition} from "../../domain/interfaces/booking-scroll-position.interface";

@Injectable({providedIn: 'root'})
export class BookingScrollPositionIndexedDBAdapter extends IndexedDBRepository<BookingScrollPosition> implements BookingScrollPositionRepository {
  readonly dbName = DATABASE_NAME;
  readonly instanceName = STORE_DATABASE.scrollPosition;

  get(serviceId: string): Observable<BookingScrollPosition | null> {
    return this.getItem(serviceId);
  }

  save(position: BookingScrollPosition): Observable<void> {
    return this.setItem(position.serviceId, position)
      .pipe(
        map(() => void 0));
  }

  delete(serviceId: string): Observable<void> {
    return this.removeItem(serviceId);
  }

  cleanup(): Observable<void> {
    return this.clearAll();
  }
}
